export const en = {
    'build-date': 'Report date',
    download: 'Download report',
    'end-date': 'End date',
    id: 'ID',
    link: 'Download report',
    'start-date': 'Start date',
    status: 'Status'
};
